import AddIcon from '@mui/icons-material/Add'
import {Button} from '@mui/material'
import React from 'react'
import {useTranslation} from 'react-i18next'
import {useNavigate, useSearchParams} from 'react-router'

import {FEATURE_NAMESPACE} from '../../localization'

export const NewAnalysisButton: React.FC = () => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()

  return (
    <>
      <Button
        startIcon={<AddIcon />}
        onClick={() => navigate(`../new?${searchParams.toString()}`)}
        color="primary"
        variant="contained"
        data-test-id={'analysis-add-button'}
        id={'analysis-add-button'}
        sx={{position: 'absolute', right: '15px', top: '12px'}}
      >
        {t('buttons.createAnalysis')}
      </Button>
    </>
  )
}
